export enum DisplayAreas {
  EntireApplication,
  LearningMap,
}
